export default "__VITE_ASSET__XbfKTzJH__"